var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconRpmNavigation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15789_52198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 22.5C14.1247 21.3392 13.6038 19.9501 13.5 18.5",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 22.5H16.5",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 15.5H23.5",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 1.5H1.5C0.947715 1.5 0.5 1.94772 0.5 2.5V17.5C0.5 18.0523 0.947715 18.5 1.5 18.5H22.5C23.0523 18.5 23.5 18.0523 23.5 17.5V2.5C23.5 1.94772 23.0523 1.5 22.5 1.5Z",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 9.49983H6.661C6.76102 9.5 6.8588 9.47017 6.9417 9.4142C7.02459 9.35822 7.08879 9.27867 7.126 9.18583L7.468 8.32883C7.50655 8.23257 7.57407 8.15068 7.66122 8.0945C7.74836 8.03831 7.85082 8.01061 7.9544 8.01522C8.05799 8.01984 8.15757 8.05654 8.23938 8.12025C8.32118 8.18396 8.38116 8.27153 8.411 8.37083L9.016 10.3878C9.04657 10.4913 9.10979 10.5821 9.19621 10.6467C9.28263 10.7112 9.38762 10.7461 9.4955 10.7461C9.60338 10.7461 9.70837 10.7112 9.79479 10.6467C9.88121 10.5821 9.94443 10.4913 9.975 10.3878L11.428 5.44883C11.4595 5.34157 11.5261 5.24797 11.6171 5.18299C11.708 5.11801 11.8182 5.08538 11.9298 5.09033C12.0415 5.09529 12.1483 5.13752 12.2332 5.2103C12.3181 5.28308 12.3761 5.3822 12.398 5.49183L13.613 11.5658C13.6349 11.6748 13.6925 11.7735 13.7767 11.8461C13.8609 11.9187 13.9669 11.9612 14.0779 11.9668C14.189 11.9724 14.2987 11.9409 14.3899 11.8771C14.481 11.8134 14.5482 11.7211 14.581 11.6148L15.581 8.35583C15.6114 8.257 15.6717 8.17003 15.7536 8.10689C15.8355 8.04376 15.9349 8.00756 16.0382 8.00328C16.1415 7.999 16.2436 8.02686 16.3304 8.08301C16.4173 8.13916 16.4845 8.22085 16.523 8.31683L16.871 9.18883C16.9082 9.28167 16.9724 9.36122 17.0553 9.4172C17.1382 9.47318 17.236 9.503 17.336 9.50283H23.5",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15789_52198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconRpmNavigation);
export default __webpack_public_path__ + "static/media/streamline-icon-rpm-navigation.90a0c28a.svg";
export { ForwardRef as ReactComponent };